import script from "./All.vue?vue&type=script&setup=true&lang=js"
export * from "./All.vue?vue&type=script&setup=true&lang=js"

export default script